import React, { useEffect, useMemo, useState } from "react";

import { viewportContext } from "./ViewportContext";

import type { FC } from "react";

const ViewportProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const onResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const value = useMemo(() => ({ width, height }), [width, height]);

  return <viewportContext.Provider value={value}>{children}</viewportContext.Provider>;
};

export default ViewportProvider;
